import { GridState } from './../infrastructure/classes/grid-state';
export class User {
  userId: string;
  password: string;
  isAdmin: boolean;
  isRestrictAddCSV: boolean;
  displayName: string;
  resetPasswordToken: string;
  resetPasswordExpires: string;
  confirmEmailToken: string;
  sendConfirmEmailExpires: number;
  preferences: any;
  addRequest: any;
  acceptedPrivacyPolicy: boolean = false;
  createdAt: Date;
  updatedAt: Date;
  gridStateItem: GridState = new GridState();
  gridStateBom: GridState = new GridState();
  gridStateInventorySelection: GridState = new GridState();
  gridStateShipmentSumary: GridState = new GridState();
  gridStateShipmentReview: GridState = new GridState();
  gridStateShipmentCasePack: GridState = new GridState();
  gridStateShipmentComplete: GridState = new GridState();
  gridStateVendor: GridState = new GridState();
  gridStateSupply: GridState = new GridState();
  gridStateDemand: GridState = new GridState();
  gridStateSummary: any;
  gridStateSummaryByVendor: any;
  gridStateCustomPo: any;
  gridStateSnapshot: any;
  gridStateUrgentCare: any;
  gridStateConsolidate: any;
  gridStateAddress: any;
  gridStatePoSaved: any;
  gridStateAmazonReceipt: any;
  gridStatePoReceipt: any;
  gridStatePoClosed: any;
  gridStateShipmentClosed: any;
  gridStateShipment: any;
  gridStateAWDShipment: any;
  gridStateAmazonReceiptDetail: any;
  gridStatePoReceiptDetail: any;
  gridStateCustomPoDetail: any;
  gridStateSuggestedPoDetail: any;
  gridStateRestockSuggestionItemList: any;
  gridStateRestockSuggestionSupplierList: GridState = new GridState();
  gridStateForecastedHistory: GridState = new GridState();
  gridStatePOItemSelection: GridState = new GridState();
  gridStatePoVault: any;
  gridStateCampaignList: GridState = new GridState();
  gridStateCampaignProductAdList: GridState = new GridState();
  gridStateCampaignItemList: GridState = new GridState();
  gridStateHistoryLogList: GridState = new GridState();
  gridStateItemPricingRecommendation: GridState = new GridState();

  globalFilters: GlobalFilters;

  constructor(init?: Partial<User>) {
    if (init) {
      //if no values are passed in, fresh instantiation
      Object.assign(this, init);
    }
  }
}


export interface GlobalFilters {
  campaign?: CampaignGlobalFilters
}


export enum DateRangePeriod {
  YESTERDAY = 'YESTERDAY',
  LAST_7_DAYS = 'LAST_7_DAYS',
  LAST_14_DAYS = 'LAST_14_DAYS',
  LAST_30_DAYS = 'LAST_30_DAYS',
  LAST_90_DAYS = 'LAST_90_DAYS',
  CUSTOM = 'CUSTOM',
}

export interface CampaignGlobalFilters { 
  dateRange: {
    type: DateRangePeriod;
    start?: string;
    end?: string;
  }
}